import { createUseStyles } from 'react-jss'
import Link from 'next/link'
import { Currency } from './Currency'
import { Badge } from './Badge'
import { useCart } from './Cart'
import { calculateProductPrices } from '../../utils'

const useStyles = createUseStyles({
    actionBox: {
        background: 'linear-gradient(0deg, rgba(0,0,0,0.60) 20%, rgba(255,255,255,0) 40%)',
        width: '100%',
        height: '100%',
        display: 'inline-block',
        padding: '15px'
    },
    postCard: {
        position: 'relative',
        width: '100%',
        height: '100%',
        margin: '0 auto',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }
})

const OutOfStock = () => (
    <span className="price inline-block text-xs float-right px-3 py-1 bg-red-200 text-red-500 rounded-md">
        اتمام موجودی
    </span>
)

function HomePost({ imageUrl, faName, enName, price, salePrice, stock, href, product }) {
    const classes = useStyles()
    const cart = useCart()

    let res = <></>

    let hasDiscount = salePrice && salePrice < price

    let CurrencyWidget = (
        <Currency
            product={{
                metas: {
                    price: {
                        value: price
                    },
                    sale_price: {
                        value: salePrice
                    }
                }
            }}
        />
    )
    if (product) {
        const calcs = calculateProductPrices(product)
        price = calcs.price
        salePrice = calcs.sale_price
        hasDiscount = calcs.hasDiscount
        CurrencyWidget = <Currency product={product} />
    }

    const IsInCart = () => (
        <span className="text-white inline-block whitespace-no-wrap">
            <svg
                className="w-4 text-white inline"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
            </svg>{' '}
            در سبد خرید
        </span>
    )
    if (!stock || stock <= 0) res = <OutOfStock />
    else if (!hasDiscount)
        res = (
            <div className="flex align-baseline justify-between">
                <span className="price inline-block text-xs float-right px-3 py-1 bg-gray-200 text-green-800 rounded-md">
                    {CurrencyWidget}
                </span>
                {cart.exists(product.id) && <IsInCart />}
                <span
                    className={
                        price ? 'mr-2 float-left text-xs bg-pink-400 text-white py-1 px-2 rounded-md addCart' : 'hidden'
                    }
                >
                    مشاهده محصول
                </span>
            </div>
        )
    else
        res = (
            <div className="flex align-baseline justify-between">
                <span className="price inline-block text-xs float-right px-3 py-1 bg-gray-200 text-gray-600 rounded-md relative">
                    <span
                        className="text-sm absolute line-through text-black bg-gray-200 p-1 rounded-t-md right-0"
                        style={{ top: -15, zIndex: 99 }}
                    >
                        <Currency value={price} />
                    </span>
                    <span className="relative" style={{ zIndex: 100 }}>
                        {CurrencyWidget}
                    </span>
                </span>
                {cart.exists(product.id) && <IsInCart />}
                <span
                    className={
                        price
                            ? 'mr-2 float-left text-xs text-center bg-red-400 text-white py-1 px-2 rounded-md addCart'
                            : 'hidden'
                    }
                >
                    مشاهده محصول
                </span>
            </div>
        )

    return (
        <div
            className={classes.postCard}
            style={{
                backgroundImage: `url(/api/${imageUrl})`
            }}
        >
            <Link href={href || ''}>
                <a>
                    <div className={classes.actionBox}>
                        {hasDiscount && (
                            <Badge text={`${Math.round(((price - salePrice) * 100) / price)}% تخفیف`} type="off" />
                        )}
                        <h3
                            className="text-white text-right mb-2 h-6 text-lg 2xl:text-xl fristHead truncate"
                            style={{ textShadow: '1px 1px 2px black' }}
                        >
                            {faName}
                        </h3>

                        <h4 className="text-white text-right mb-2 h-6 truncate">{enName}</h4>
                        {res}
                    </div>
                </a>
            </Link>
        </div>
    )
}

export { HomePost }

const PLACEHOLDER =
    'url("data:image/jpeg;base64,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")'
